import { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch, useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table, Button } from 'react-bootstrap';
import { result, liststatus, updateElearningResult } from '../../store/studentresult/actions';
import { queryclear } from  '../../store/search/actions';
import loadinglogo from '../../img/loading.gif';
import StudentHeader from './studentheader';
import StudentFooter from './studentfooter';
import { createPage } from '../tab/pagetab';
import { Util } from '../../api/util';
import { AlertContainer, alert } from 'react-custom-alert';
import 'react-custom-alert/dist/index.css';
import RefreshIcon from '@material-ui/icons/Refresh';

interface SearchReducerHandlers {
    dispatch: any;
    search: string;
    page: number;
    limit: number;
    updating: boolean;
    setUpdating: (v: boolean) => void;
    setError: (v: string) => void;
    setLoading: (v: boolean) => void;
    setStatusItems: (v: any) => void;
    setInitStatus: (v: number) => void;
    setItems: (v: any) => void;
    setInit: (v: number) => void;
}

const handleReducerUpdating = (h: SearchReducerHandlers) => h.setUpdating(true);

const handleReducerUpdated = (h: SearchReducerHandlers) => {
    h.setUpdating(false);
    h.dispatch(queryclear());
    h.dispatch(result(h.search, h.page, h.limit));
    alert({ message: 'อัปเดตผลการเรียนสำเร็จ', type: 'success' });
};

const handleReducerLoading = (h: SearchReducerHandlers) => {
    h.setError('');
    h.setLoading(true);
};

const handleReducerLoadedData = (res: any, h: SearchReducerHandlers) => {
    if (res.data == null) return;
    if (res.table === "status") {
        h.setStatusItems(res.data);
        h.setInitStatus(1);
        return;
    }
    if (res.table === "result") {
        h.setLoading(false);
        h.setError('');
        h.setItems(res.data);
        h.setInit(1);
    }
};

const handleReducerFailed = (res: any, h: SearchReducerHandlers) => {
    if (h.updating) {
        h.setUpdating(false);
        h.dispatch(queryclear());
        alert({ message: 'อัปเดตผลการเรียนไม่สำเร็จ', type: 'error' });
        return;
    }
    h.setError(res.data.message);
    h.setLoading(false);
};

const handleSearchReducerChange = (res: any, h: SearchReducerHandlers) => {
    if (res.isUpdating) return handleReducerUpdating(h);
    if (res.isUpdated) return handleReducerUpdated(h);
    if (res.isLoading) return handleReducerLoading(h);
    if (res.isLoaded && !res.isUpdated) return handleReducerLoadedData(res, h);
    if (res.isFailed) return handleReducerFailed(res, h);
};

const getResultColor = (r: string) => {
    if ((r === "P") || (r === "PX")) return "green";
    if (r === "F") return "red";
    return "black";
};

const getResultLabel = (r: string, statusItems: any) => {
    for (let i = 0; i < statusItems.length; i++) {
        if (statusItems[i].code === r) return statusItems[i].name;
    }
    return r;
};

const renderResultRow = (item: any, index: number, statusItems: any) => (
    <tr key={index} style={{ backgroundColor: (index % 2 === 1) ? "white" : "#F5F5F5" }}>
        <td className="text-left">{item.shortName} : {item.project} รอบที่ {item.session}<br/>
        <span className="yellow">{(item.courseShortName===null)?"":item.courseShortName+" :"} {item.courseName}</span>
        </td>
        <td>
            {Util.datetostr(new Date(item.fromDate))} - {Util.datetostr(new Date(item.toDate))}
        </td>
        <td> <span style={{color:getResultColor(item.result)}}>
            {getResultLabel(item.result, statusItems)}<br/>
            { (item.resultDate!==null)?Util.datetostr(new Date(item.resultDate)):""}
            </span>
        </td>
        <td>
        </td>
    </tr>
);

const renderResultTable = (items: any, statusItems: any) =>
    items.items.map((item: any, index: number) => renderResultRow(item, index, statusItems));

const StudentResult= () => {
    const [init,setInit] = useState(0);
    const [initStatus,setInitStatus] = useState(0);
    const [items,setItems] = useState<any>({items:[]});
    const [statusItems,setStatusItems] = useState<any>({});
    const [page,setPage] = useState(0);
    const [limit,setLimit] = useState(10);
    const [search,setSearch] = useState("");
    const [loading,setLoading] = useState(false)
    const [error, setError] = useState('');
    const [updating,setUpdating] = useState(false)
    const store = useStore();
    const dispatch = useDispatch();
    const history = useHistory(); 

    useEffect(() => {
        const handlers: SearchReducerHandlers = {
            dispatch, search, page, limit, updating,
            setUpdating, setError, setLoading, setStatusItems, setInitStatus, setItems, setInit
        };
        const unsubscribe = store.subscribe(() => {
            handleSearchReducerChange(store.getState().SearchReducer, handlers);
        });
        return unsubscribe;
       }, [search,page,limit,updating])

       useEffect(() => {
        dispatch(queryclear());
        dispatch(result("",0,limit));
        dispatch(liststatus())
       }, [])

    const handlePage = (p:number) => {
        setPage(p);
        dispatch(result(search,p,limit));
    }

    const handleLimit = (l:number) => {
        setLimit(l);
        dispatch(result(search,0,l));
    }

    const searchTimeout = useRef<ReturnType<typeof setTimeout>>();

    const handleSearch = (s:string) => {
        setSearch(s);
        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }
        searchTimeout.current = setTimeout(() => {
            dispatch(result(s,page,limit));
        }, 500);
    }

    const handleUpdateElearningResult = () => {
        dispatch(updateElearningResult());
    }

    const getTotalItem = () => {
        return items.totalItem;
    }

    const getTotalPage = () => {
        return items.totalPage;
    }

    return (<><div className="App-student">
    <AlertContainer floatingTime={3000}/>
    <div className="student-wrapper">
    <div className="student-wrapper-header-inner" style={{ background: "#38383D" }}>
    <StudentHeader/>
    <input className="search-box" type="text" placeholder="ค้นหาคอร์สเรียน..." value={search} onChange={e=>{handleSearch(e.currentTarget.value)}}/>
    <div style={{ textAlign: "center", height: "30px" }}>
    { (((init===0) || (loading)) && (error==="")) &&
        <img src={loadinglogo} width="30" height="30" className="d-inline-block align-top" alt="" />
    }
    </div>
    { (error!=="") &&
        <div style={{ color: 'red', textAlign: "center" }}>{error}</div>
    }
    </div>
    { (init===1) &&
     <>    
    <div className="student-wrapper-inner">
    <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
    <Button
        disabled={updating}
        onClick={handleUpdateElearningResult}
        style={{
            backgroundColor: "#fcb134",
            borderColor: "#fcb134",
            color: "white",
            fontWeight: "bold",
            borderRadius: "6px",
            width: "190px",
            whiteSpace: "nowrap",
            opacity: updating ? 0.6 : 1
        }}
    >
        <RefreshIcon fontSize="small" className={updating ? "spin-icon" : ""} style={{ marginRight: "6px" }}/>
        { updating ? "กำลังอัปเดต..." : "อัปเดตผลการเรียน" }
    </Button>
    </div>
    <Table striped hover responsive="sm" cellPadding="0px" cellSpacing="0px" style={{
        borderTopStyle: "hidden",
        borderStyle: "hidden",
    }}>
                <thead className="black" style={{
        borderTopStyle: "hidden",
        borderStyle: "hidden",
    }}>
                    <tr style={{borderRadius:"10px"}}>
                        <th className='gray-button text-left w100'>หลักสูตร</th>
                        <th className='gray-button w100'>วันที่เรียน</th>                        
                        <th className='gray-button w100'>สถานะ</th>
                        <th className='gray-button w100'>วุฒิบัตร</th>
                    </tr>
                </thead>
                <tbody style={{fontSize:"22px"}}>
                    { renderResultTable(items, statusItems) }
                </tbody>
    </Table>
    <div className='row'>
        <div className='col-3' style={{textAlign:"left", justifyContent:"left"}}>
            ทั้งหมด {Util.integerWithCommas(getTotalItem())} รายการ
        </div>
        <div className='col-6 row' style={{textAlign:"center", justifyContent:"center"}}>
            {
                createPage(page,getTotalPage(),handlePage)
            }
        </div>        
        <div className='col-3' style={{justifyContent:"right",paddingRight:"0px"}}>
            <div className='row' style={{justifyContent:"right",paddingRight:"0px"}}>
        <div style={{textAlign:"right",marginTop:"auto",marginBottom:"auto"}}>จำนวนรายการต่อหน้า</div>&nbsp;
        <select className="form-control" style={{width:"80px"}} name="page" value={limit} onChange={e=>handleLimit(parseInt(e.target.value))}>
                            <option value="0">All</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
        </select>
        </div>
        </div>
    </div>
    </div>
    <br/>
    <br/>
    </>
    }
    <StudentFooter/>
    </div>
    </div>
    </>);
}

export default StudentResult;